import React from "react"; 
import "./App.css";
import "./rtl.css";
import { Routes, Route } from "react-router-dom";
import Login from "./screens/LoginRegister/Login";
import LogoutComponent from "./components/Auth/LogoutComponent";
import Register from "./screens/LoginRegister/Register";  
import IntegrationScreens from "./screens/Integration Screen/IntegrationScreens";
import AppFormsListing from "./components/Lynkaz Integrations/App Forms/AppFormsListing";
import TenantFormsListings from "./components/Lynkaz Integrations/Tenant Forms/TenantFormsListings";
import ApiMasterFormsListings from "./components/Lynkaz Integrations/API Master Forms/ApiMasterFormsListings";
import AppMasterFormsListings from "./components/Lynkaz Integrations/App Master Forms/AppMasterFormsListings";
import OperationMappingFormsListings from "./components/Lynkaz Integrations/Operation Mapping Forms/OperationMappingFormsListings";
import ExternalSystemApiFormsListings from "./components/Lynkaz Integrations/External System API Forms/ExternalSystemApiFormsListings";
import ApiDetailsFormsListings from "./components/Lynkaz Integrations/API Details Forms/ApiDetailsFormsListings";
import CredentialStoreFormsListings from "./components/Lynkaz Integrations/Credentials Store Forms/CredentialStoreFormsListings";
import NotFoundScreen from "./screens/Not Found/NotFoundScreen";
import AppFormsDetailView from "./components/Lynkaz Integrations/App Forms/AppFormsDetailView"; 
import ApiMasterFormsDetailView from "./components/Lynkaz Integrations/API Master Forms/ApiMasterFormsDetailView";
import AppMasterFormsDetailView from "./components/Lynkaz Integrations/App Master Forms/AppMasterFormsDetailView";
import OperationMappingFormsDetailView from "./components/Lynkaz Integrations/Operation Mapping Forms/OperationMappingFormsDetailView";
import ExternalSystemApiFormsDetailView from "./components/Lynkaz Integrations/External System API Forms/ExternalSystemApiFormsDetailView";
import CredentialStoreFormsDetailView from "./components/Lynkaz Integrations/Credentials Store Forms/CredentialStoreFormsDetailView";
import ApiDetailsFormsDetailView from "./components/Lynkaz Integrations/API Details Forms/ApiDetailsFormsDetailView";
import IntegrationMonitor from "./components/Lynkaz Integrations/Integration Monitor/IntegrationMonitor";
import ApiManagerListings from "./components/Lynkaz Integrations/API Manager Forms/ApiManagerListings";
import ApiManagerDetailView from "./components/Lynkaz Integrations/API Manager Forms/ApiManagerDetailView";

function App() {
  // here all screens will rendered according to the routes! 
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<LogoutComponent />} />
      <Route path="/" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route path="/system-integration" element={<IntegrationScreens />} />

      <Route path="/api-manager-forms" element={<ApiManagerListings />} />
      <Route path="/app-forms" element={<AppFormsListing />} />
      <Route path="/tenant-forms" element={<TenantFormsListings />} />
      <Route path="/api-master-forms" element={<ApiMasterFormsListings />} />
      <Route path="/app-master-forms" element={<AppMasterFormsListings />} />
      <Route path="/operation-mapping-forms" element={<OperationMappingFormsListings />} />
      <Route path="/external-system-api-forms" element={<ExternalSystemApiFormsListings />} />
      <Route path="/lynkaz-api-details-forms" element={<ApiDetailsFormsListings />} />
      <Route path="/credentials-store-forms" element={<CredentialStoreFormsListings />} />
      <Route path="/integration-monitor-forms" element={<IntegrationMonitor />} />

      <Route path="/edit-api-manager-form/:id" element={<ApiManagerDetailView />} />
      <Route path="/edit-app-form/:id" element={<AppFormsDetailView />} /> 
      <Route path="/edit-api-master-form/:id" element={<ApiMasterFormsDetailView />} />
      <Route path="/edit-app-master-form/:id" element={<AppMasterFormsDetailView />} />
      <Route path="/edit-operation-mapping-form/:id" element={<OperationMappingFormsDetailView />} />
      <Route path="/edit-external-system-api/:id" element={<ExternalSystemApiFormsDetailView />} />
      <Route path="/edit-credential-store/:id" element={<CredentialStoreFormsDetailView />} />
      <Route path="/edit-lynkaz-api-details/:id" element={<ApiDetailsFormsDetailView />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
}

export default App;